import React from "react";
import ReactDOM from "react-dom/client";
import {
  HashRouter as Router,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import "./index.css";
import Wrapper from "./components/Wrapper";
// Redux
import { Provider } from "react-redux";

// Store
import store from "./redux/store";
const root = ReactDOM.createRoot(document.getElementById("reactJS-page"));

root.render(
  <Provider store={store}>
    <Router>
      <Wrapper />
    </Router>
  </Provider>
);
